<template>
<div>
  <div class="title-text font-weight-bold mt-5" :class="isFormNonPo ? 'print-page-break':''">
    Payment details
  </div>
  <div class="row my-2">
    <div class="col-md-6 col-12 mt-3" v-if="this.filteredFormData.paymentType">
      <div class="form-text">Type of payment</div>
      <div>{{this.filteredFormData.paymentType}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.bankAccountHolderName">
      <div class="form-text">Account holder name</div>
      <div class="wrap-text">{{filteredFormData.bankAccountHolderName}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.bankName">
      <div class="form-text">Bank name</div>
      <div class="wrap-text">{{filteredFormData.bankName}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="formattedCountryText">
      <div class="form-text">Bank country of origin</div>
      <div class="wrap-text">{{formattedCountryText}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.bankAccountNumber">
      <div class="form-text">Bank account number</div>
      <div v-if="isFormEligibleForBankDropDown">
        <div>{{toggleMaskedUnmaskedBankAccountNumber}}</div>
        <div class="mt-1 d-inline-block">
          <input type="checkbox"
                 id="showBankAccount"
                 v-model="showBankAccountNumber"/>
          <span @click="showBankAccountNumber = !showBankAccountNumber" class="ml-1 d-inline-block cursor-pointer">{{FORM_LABELS.SHOW_BANK_ACCOUNT_NUMBER}}</span>
        </div>
      </div>
      <div v-else>{{toggleMaskedUnmaskedBankAccountNumber}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.bankIBAN">
      <div class="form-text">IBAN</div>
      <div class="wrap-text">{{maskedIBAN}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.bankNumber">
      <div class="form-text">Bank and branch code</div>
      <div class="wrap-text">{{filteredFormData.bankNumber}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.bankSwiftCode">
      <div class="form-text">Swift code</div>
      <div>{{filteredFormData.bankSwiftCode}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.directDebitDeductionDate">
      <div class="form-text">Direct debit deduction date</div>
      <div>{{filteredFormData.directDebitDeductionDate}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.payrollPaymentDate">
      <div class="form-text">Payroll payment date</div>
      <div>{{filteredFormData.payrollPaymentDate}}</div>
    </div>
    <div class="col-md-6 col-12 mt-3" v-if="filteredFormData.boletoSlipExpiryDate">
      <div class="form-text">{{FORM_LABELS.BOLETO_SLIP_EXPIRY_DATE}}</div>
      <div>{{filteredFormData.boletoSlipExpiryDate}}</div>
    </div>
  </div>
</div>
</template>

<script>
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import CONSTANTS from "@/store/constants";

export default {
  name: "PreviewFormPaymentDetails",
  props: {
    filteredFormData: Object
  },
  data(){
    return{
      showBankAccountNumber : false
    }
  },
  mixins: [PaymentFormsMixin],
  computed: {
    formattedCountryText() {
      if(this.filteredFormData.bankCountry) {
        return this.getTextValue(this.adminDataList.countryCodeList, this.filteredFormData.bankCountry)
      } else {
        return ''
      }
    },
    isFormNonPo() {
      return this.$route.name.includes(CONSTANTS.NON_PO_PAYMENT_FORM)
    },
    toggleMaskedUnmaskedBankAccountNumber() {
      if (this.showBankAccountNumber) return this.filteredFormData.bankAccountNumber
      else return Array(this.filteredFormData.bankAccountNumber.length+1).join("X")
    },
    maskedIBAN() {
      return Array(this.filteredFormData.bankIBAN.length+1).join("X")
    }
  }
}
</script>

<style scoped>

</style>